// Quick validation https://stackoverflow.com/a/32686261
export const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
